import React from 'react';
import { MotionConfig } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Exp from './components/Experience';
import Contact from './components/Contact';
import ScrollProgress from './components/ScrollProgress';
import BackToTop from './components/BackToTop';
import './assets/styles/main.css';

const App: React.FC = () => {
  return (
    <MotionConfig reducedMotion="user">
      <div>
        <ScrollProgress />
        <Header />
        <Hero />
        <About />
        <Exp />
        <Contact />
        <BackToTop />
      </div>
    </MotionConfig>
  );
};

export default App;
